import React, { Component } from 'react'
import { connect } from "react-redux";
import axios from 'axios';
import { Table } from 'reactstrap';
import { Helmet } from 'react-helmet-async';
import IconButton from '@mui/material/IconButton';
import { NotificationManager } from 'react-notifications';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';

import TextField from '@mui/material/TextField';
// intl messages
import IntlMessages from 'Util/IntlMessages';
// page title bar
import PageTitleBar from 'Components/PageTitleBar/PageTitleBar';
// app config
import AppConfig from 'Constants/AppConfig';
import AuthHeader from 'Constants/AuthHeader';
import ConfirmationDialog from "Routes/common/ConfirmationDialog";
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import {
   allAcademys,
   addAcademy,
   editAcademy,
   statusAcademy,
   deleteAcademy
} from 'Actions';

// rct card box
import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';

function TabContainer({ children }) {
   return (
      <Typography component="div" style={{ padding: 8 * 3 }}>
         {children}
      </Typography>
   );
}

class academy extends Component {

   constructor(props) {

      super(props);
      this.confirmationDialog = React.createRef();
      this.state = {
         activeIndex: 0,
         name: '',
         adddiv: true,
         editdiv: false,
         eid: '',
         edname: '',
         edstrole: '',
         chkbox: false,
         addchkbox: false,
         academylist: [],
         programlist: [],
         programname: '',
         pgadddiv: true,
         pgeditdiv: false,
         programid: '',
         programedname: '',
         programInclusionlist: [],
         pgminclusionname: '',
         pginadddiv: true,
         pgineditdiv: false,
         pgminclusionid: '',
         pgminclusionedname: '',
      };
      this.addHandleSubmit = this.addHandleSubmit.bind(this);
      this.deleteAcademy = this.deleteAcademy.bind(this);
      this.editAcademy = this.editAcademy.bind(this);
      this.statusAcademy = this.statusAcademy.bind(this);
      this.editHandleSubmit = this.editHandleSubmit.bind(this);
      this.onBackSection = this.onBackSection.bind(this);

      this.addProgramSubmit = this.addProgramSubmit.bind(this);
      this.deleteProgram = this.deleteProgram.bind(this);
      this.editProgram = this.editProgram.bind(this);
      this.statusProgram = this.statusProgram.bind(this);
      this.editProgramSubmit = this.editProgramSubmit.bind(this);

      this.addPgmInclusionSubmit = this.addPgmInclusionSubmit.bind(this);
      this.deletePgmInclusion = this.deletePgmInclusion.bind(this);
      this.editPgmInclusion = this.editPgmInclusion.bind(this);
      this.statusPgmInclusion = this.statusPgmInclusion.bind(this);
      this.editPgmInclusionSubmit = this.editPgmInclusionSubmit.bind(this);

   }

   UNSAFE_componentWillMount() {
      this.getAllProgram();
      this.getAllProgramInclusion();
      this.props.allAcademys();
   }


   addHandleSubmit(event) {
      event.preventDefault();
      this.props.addAcademy(this.state.name).then((data) => {

         if (data.status == 1) {
            this.setState({
               name: ''
            });
         }
      });

   }

   deleteAcademy(acdyval) {
      this.id = acdyval.aadID;
      this.confirmationDialog.current.openDialog();
   }

   deleteDataPermanent(popupResponse) {

      if (popupResponse) {
         this.props.deleteAcademy(this.id);
         this.data = ""
      }
   }

   editAcademy(rawdata) {

      if (rawdata.xrl_stdrole == 1) {
         this.setState({ chkbox: true });
      } else {
         this.setState({ chkbox: false });
      }

      this.setState({
         eid: rawdata.aadID,
         edname: rawdata.aad_name,
         adddiv: false,
         editdiv: true
      });
   }

   editHandleSubmit(event) {
      event.preventDefault();

      this.props.editAcademy(this.state.edname, this.state.eid).then((data) => {

         if (data.status == 1) {
            setTimeout(this.onBackSection, 6000)
         }
      });

   }

   statusAcademy(id, status) {
      this.props.statusAcademy(id, status);
   }

   onBackSection() {
      this.setState({
         adddiv: true,
         editdiv: false,
         pgadddiv: true,
         pgeditdiv: false,
         pginadddiv: true,
         pgineditdiv: false,
      });
   }

   handleChange(value) {
      this.setState({ activeIndex: value });
   }

   // Program Functions
   getAllProgram() {
      axios.get(AppConfig.apiurl + '/api/getprograms', { headers: AuthHeader.header })
         .then(response => {
            const allprogram = response.data.data;
            this.setState({ programlist: allprogram })
         });
   }

   addProgramSubmit(event) {
      event.preventDefault();

      var payload = {
         "name": this.state.programname
      }
      axios.post(AppConfig.apiurl + '/api/addprogram', payload, { headers: AuthHeader.header })
         .then(response => {
            if (response.status == 200) {
               var resdata = response.data;
               if (resdata.status === 1) {
                  NotificationManager.success(resdata.message);
                  this.getAllProgram();
                  this.setState({ programname: '' });
               } else {
                  NotificationManager.error(resdata.message);
               }
            } else {
               NotificationManager.error('Program not added');
            }

         })
         .catch(error => {
            NotificationManager.error(error);
         });


   }

   deleteProgram(programid) {
      if (window.confirm('Are you sure to delete this Program?')) {

         var payload = {
            "id": programid
         }
         axios.post(AppConfig.apiurl + '/api/deleteprogram', payload, { headers: AuthHeader.header })
            .then(response => {
               var resdata = response.data;
               if (resdata.status === 1) {
                  NotificationManager.success(resdata.message);
                  this.getAllProgram();
               } else {
                  NotificationManager.error(resdata.message);
               }

            })
            .catch(error => {
               NotificationManager.error(error);
            });
      }
   }

   editProgram(rawdata) {

      this.setState({
         programid: rawdata.id,
         programedname: rawdata.name,
         pgadddiv: false,
         pgeditdiv: true
      });
   }

   editProgramSubmit(event) {
      event.preventDefault();

      var payload = {
         "id": this.state.programid,
         "name": this.state.programedname
      }
      axios.post(AppConfig.apiurl + '/api/editprogram', payload, { headers: AuthHeader.header })
         .then(response => {
            var resdata = response.data;
            if (resdata.status === 1) {
               NotificationManager.success(resdata.message);
               this.getAllProgram();
               setTimeout(this.onBackSection, 6000)
            } else {
               NotificationManager.error(resdata.message);
            }

         })
         .catch(error => {
            NotificationManager.error(error);
         });

   }

   statusProgram(id, status) {
      var payload = {
         "id": id,
         "status": status
      }
      axios.post(AppConfig.apiurl + '/api/statusprogram', payload, { headers: AuthHeader.header })
         .then(response => {
            var resdata = response.data;
            if (resdata.status === 1) {
               NotificationManager.success(resdata.message);
               this.getAllProgram();
            } else {
               NotificationManager.error(resdata.message);
            }

         })
         .catch(error => {
            NotificationManager.error(error);
         });
   }

   // Program Inclusion Functions
   getAllProgramInclusion() {
      axios.get(AppConfig.apiurl + '/api/getprograminclusions', { headers: AuthHeader.header })
         .then(response => {
            const allpgminclusion = response.data.data;
            this.setState({ programInclusionlist: allpgminclusion })
         });
   }

   addPgmInclusionSubmit(event) {
      event.preventDefault();

      var payload = {
         "name": this.state.pgminclusionname
      }
      axios.post(AppConfig.apiurl + '/api/addprograminclusions', payload, { headers: AuthHeader.header })
         .then(response => {
            if (response.status == 200) {
               var resdata = response.data;
               if (resdata.status === 1) {
                  NotificationManager.success(resdata.message);
                  this.getAllProgramInclusion();
                  this.setState({ pgminclusionname: '' });
               } else {
                  NotificationManager.error(resdata.message);
               }
            } else {
               NotificationManager.error('Program Inclusion not added');
            }

         })
         .catch(error => {
            NotificationManager.error(error);
         });


   }

   deletePgmInclusion(programid) {
      if (window.confirm('Are you sure to delete this Program Inclusion?')) {

         var payload = {
            "id": programid
         }
         axios.post(AppConfig.apiurl + '/api/deleteprograminclusions', payload, { headers: AuthHeader.header })
            .then(response => {
               var resdata = response.data;
               if (resdata.status === 1) {
                  NotificationManager.success(resdata.message);
                  this.getAllProgramInclusion();
               } else {
                  NotificationManager.error(resdata.message);
               }

            })
            .catch(error => {
               NotificationManager.error(error);
            });
      }
   }

   editPgmInclusion(rawdata) {

      this.setState({
         pgminclusionid: rawdata.apiID,
         pgminclusionedname: rawdata.api_name,
         pginadddiv: false,
         pgineditdiv: true
      });
   }

   editPgmInclusionSubmit(event) {
      event.preventDefault();

      var payload = {
         "id": this.state.pgminclusionid,
         "name": this.state.pgminclusionedname
      }
      axios.post(AppConfig.apiurl + '/api/editprograminclusions', payload, { headers: AuthHeader.header })
         .then(response => {
            var resdata = response.data;
            if (resdata.status === 1) {
               NotificationManager.success(resdata.message);
               this.getAllProgramInclusion();
               setTimeout(this.onBackSection, 6000)
            } else {
               NotificationManager.error(resdata.message);
            }

         })
         .catch(error => {
            NotificationManager.error(error);
         });

   }

   statusPgmInclusion(id, status) {
      var payload = {
         "id": id,
         "status": status
      }
      axios.post(AppConfig.apiurl + '/api/statusprograminclusions', payload, { headers: AuthHeader.header })
         .then(response => {
            var resdata = response.data;
            if (resdata.status === 1) {
               NotificationManager.success(resdata.message);
               this.getAllProgramInclusion();
            } else {
               NotificationManager.error(resdata.message);
            }

         })
         .catch(error => {
            NotificationManager.error(error);
         });
   }

   render() {
      // const { match, academylists, loading } = this.props; kk
      const { academylists, loading } = this.props;

      return (
         <div className="saas-dashboard">
            <Helmet>
               <title>Academy | {AppConfig.appTitle}</title>
               <meta name="description" content="Reactify Sass Dashboard" />
            </Helmet>
            {/* <PageTitleBar title={<IntlMessages id="sidebar.academyheading" />} match={match} /> */}
            <PageTitleBar title={<IntlMessages id="sidebar.academyheading" />} />


            <RctCollapsibleCard >
               {/* <Tabs
                  value={this.state.activeIndex}
                  onChange={(e, value) => this.handleChange(value)}
                  variant="fullWidth"
                  textColor="primary"
                  indicatorColor="primary">
                  <Tab label="ACADEMY" />
               </Tabs> */}

               {this.state.activeIndex === 0 &&
                  <TabContainer>
                     <div className="row">
                        <div className="col-sm-12 col-lg-8">
                           <RctCollapsibleCard heading="List">
                              <div className="table-responsive">
                                 <Table hover bordered striped>
                                    <thead>
                                       <tr className="bg-primary text-white">
                                          <th>Sl.No</th>
                                          <th>Name</th>
                                          <th>Action</th>
                                       </tr>
                                    </thead>
                                    <tbody>
                                       {academylists.map((acdyval, idx) => (
                                          <tr key={idx}>
                                             <td>{idx + 1}</td>
                                             <td>{acdyval.aad_name}</td>
                                             <td>
                                                {acdyval.aad_staus == 1 ? (
                                                   <a herf="" onClick={() => this.statusAcademy(acdyval.aadID, 0)}><span className="badge badge-info" >Active</span></a>
                                                ) : (
                                                   <a herf="" onClick={() => this.statusAcademy(acdyval.aadID, 1)}><span className="badge badge-danger" >Inactive</span></a>
                                                )}
                                                <IconButton className="text-info" aria-label="edit" onClick={() => this.editAcademy(acdyval)}><EditOutlinedIcon/></IconButton>
                                                <IconButton className="text-danger" aria-label="Delete" onClick={() => this.deleteAcademy(acdyval)}><DeleteOutlineOutlinedIcon/></IconButton>
                                             </td>
                                          </tr>
                                       ))}

                                    </tbody>
                                 </Table>
                              </div>
                           </RctCollapsibleCard>
                           <ConfirmationDialog
                           ref={this.confirmationDialog}
                           onConfirm={(res) => this.deleteDataPermanent(res)}
                           data={'Academy'}
                        />
                        </div>
                        {this.state.adddiv &&
                           <div className="col-sm-6 col-lg-4">
                              <RctCollapsibleCard heading="Add Academy">
                                 <form autoComplete="off" onSubmit={(e) => this.addHandleSubmit(e)}>
                                    <div className="row">
                                       <div className="col-sm-12 col-lg-6 col-xl-12">
                                          <div className="form-group">
                                             <TextField id="name" fullWidth label="Name" required value={this.state.name} onChange={evt => this.setState({ name: evt.target.value })} />
                                          </div>
                                          <div className="form-group">
                                             <input type="submit" className="mr-3 mb-3 btn btn-outline-primary" value="Submit" />

                                          </div>
                                       </div>
                                    </div>
                                 </form>
                              </RctCollapsibleCard>
                           </div>
                        }

                        {this.state.editdiv &&
                           <div className="col-sm-6 col-lg-4">
                              <RctCollapsibleCard heading="Edit Academy">
                                 <form autoComplete="off" onSubmit={this.editHandleSubmit}>
                                    <div className="row">
                                       <div className="col-sm-12 col-lg-6 col-xl-12">
                                          <div className="form-group">
                                             <TextField id="name" fullWidth label="Name" required value={this.state.edname} onChange={evt => this.setState({ edname: evt.target.value })} />
                                          </div>
                                          <div className="form-group">
                                             <input type="submit" className="mr-3 mb-3 btn btn-outline-primary" value="Update" />
                                             <input type="button" className="mr-3 mb-3 btn btn-outline-warning" onClick={this.onBackSection} value="Back" />

                                          </div>
                                       </div>
                                    </div>
                                 </form>
                              </RctCollapsibleCard>
                           </div>
                        }
                     </div>

                  </TabContainer>}
               {this.state.activeIndex === 1 &&
                  <TabContainer>

                     <div className="row">
                        <div className="col-sm-12 col-lg-8">
                           <RctCollapsibleCard heading="List">
                              <div className="table-responsive">
                                 <Table hover bordered striped>
                                    <thead>
                                       <tr className="bg-primary text-white">
                                          <th>Sl.No</th>
                                          <th>Name</th>
                                          <th>Action</th>
                                       </tr>
                                    </thead>
                                    <tbody>
                                       {this.state.programlist.map((prgval, idx) => (
                                          <tr key={idx}>
                                             <td>{idx + 1}</td>
                                             <td>{prgval.name}</td>
                                             <td>
                                                {prgval.status == 1 ? (
                                                   <a herf="" onClick={() => this.statusProgram(prgval.id, 0)}><span className="badge badge-info" >Active</span></a>
                                                ) : (
                                                   <a herf="" onClick={() => this.statusProgram(prgval.id, 1)}><span className="badge badge-danger" >Inactive</span></a>
                                                )}
                                                <IconButton className="text-info" aria-label="edit" onClick={() => this.editProgram(prgval)}><EditOutlinedIcon/></IconButton>
                                                <IconButton className="text-danger" aria-label="Delete" onClick={() => this.deleteProgram(prgval.id)}><DeleteOutlineOutlinedIcon/></IconButton>
                                             </td>
                                          </tr>
                                       ))}

                                    </tbody>
                                 </Table>
                              </div>
                           </RctCollapsibleCard>
                        </div>

                        {this.state.pgadddiv &&
                           <div className="col-sm-6 col-lg-4">
                              <RctCollapsibleCard heading="Add Program">
                                 <form autoComplete="off" onSubmit={(e) => this.addProgramSubmit(e)}>
                                    <div className="row">
                                       <div className="col-sm-12 col-lg-6 col-xl-12">
                                          <div className="form-group">
                                             <TextField id="name" fullWidth label="Name" required value={this.state.programname} onChange={evt => this.setState({ programname: evt.target.value })} />
                                          </div>
                                          <div className="form-group">
                                             <input type="submit" className="mr-3 mb-3 btn btn-outline-primary" value="Submit" />

                                          </div>
                                       </div>
                                    </div>
                                 </form>
                              </RctCollapsibleCard>
                           </div>
                        }

                        {this.state.pgeditdiv &&
                           <div className="col-sm-6 col-lg-4">
                              <RctCollapsibleCard heading="Edit Program">
                                 <form autoComplete="off" onSubmit={this.editProgramSubmit}>
                                    <div className="row">
                                       <div className="col-sm-12 col-lg-6 col-xl-12">
                                          <div className="form-group">
                                             <TextField id="name" fullWidth label="Name" required value={this.state.programedname} onChange={evt => this.setState({ programedname: evt.target.value })} />
                                          </div>
                                          <div className="form-group">
                                             <input type="submit" className="mr-3 mb-3 btn btn-outline-primary" value="Update" />
                                             <input type="button" className="mr-3 mb-3 btn btn-outline-warning" onClick={this.onBackSection} value="Back" />

                                          </div>
                                       </div>
                                    </div>
                                 </form>
                              </RctCollapsibleCard>
                           </div>
                        }
                     </div>


                  </TabContainer>}

            </RctCollapsibleCard>


         </div>
      )
   }
}





const mapStateToProps = ({ academy }) => {
   const { academylists, loading } = academy;
   return { academylists, loading };
}

export default connect(mapStateToProps, {
   allAcademys,
   addAcademy,
   editAcademy,
   statusAcademy,
   deleteAcademy
})(academy); 